import Service               from '@/api/service';
import { useSaleTypesStore } from '@/store/saleTypes';

export async function getSaleType(tenantId, saleTypeId) {

  const store = useSaleTypesStore();
  let saleType = store.saleTypes.find((saleType) => saleType.id === saleTypeId);

  if (saleType) {
    return { key : saleType.id, value : saleType.name };
  }

  saleType = await Service.getSaleType(tenantId, saleTypeId);
  return { key : saleType.id, value : saleType.name };
}

export function getIsVefaSaleType(saleTypeId) {

  const store = useSaleTypesStore();
  const saleType = store.saleTypes.find((saleType) => saleType.id === saleTypeId);
  return saleType?.type === 'vefa';
}
